import React, { useState } from "react";
import { useTranslation } from "../../useTranslation";
import {
  Typography,
  Button,
  BoundedContent,
  GridContainer,
  Column,
  Row,
  Spinner,
  Box
} from "@vp/swan";

import { useNotificationContext } from "../../NotificationContext";

import useScreenClass from "../useScreenClass";
import axios from "axios";
import { Brand, useBrand } from "@monorepo/components";
import { pushDataToSegment } from "../../segmentData";
import { MULTIPLE_ACCOUNT_FOUND_PAGE, MULTIPLE_ACCOUNT_SYNC_REQUESTED } from "../../constant";

export interface LayoutProps {
  unificationDetail?: string;
  notificationRef?: React.RefObject<HTMLDivElement>;

}

export enum PreloaderButtonState {
  Enabled = 1,
  Preloader = 2
}

const MultipleAccounts = (props: LayoutProps) => {
  const [t] = useTranslation("app");
  const { unificationDetail, notificationRef } = props;
  const { margins } = useScreenClass();
  const [submitState, setSubmitState] = useState(PreloaderButtonState.Enabled);
  const {
    unificationEmailFailed,
    unificationEmailSent
  } = useNotificationContext();
  const brand = useBrand();

  const onClick = () => {
    let unificationDetailJSON = { unificationId: "", culture: "", brand: "", ga: "", visit: "", anonymousId: "" };
    try {
      unificationDetailJSON = JSON.parse(unificationDetail || "{}");
    } catch (err) {
    }
    setSubmitState(PreloaderButtonState.Preloader);
    axios.post(`${process.env.REACT_APP_UNIFICATION_URL}unifications/${unificationDetailJSON.unificationId}/email`, {
      culture: unificationDetailJSON.culture,
      brand: Brand[brand].toLowerCase(),
      ga: unificationDetailJSON.ga,
      visit: unificationDetailJSON.visit,
      anonymousId: unificationDetailJSON.anonymousId
    }).then(() => {
      setSubmitState(PreloaderButtonState.Enabled);
      unificationEmailSent();
      if (notificationRef && notificationRef.current) {
        notificationRef.current.scrollIntoView({ behavior: "smooth" });
      }
      pushDataToSegment(MULTIPLE_ACCOUNT_SYNC_REQUESTED, false, { pageName: MULTIPLE_ACCOUNT_FOUND_PAGE });
    }).catch((err) => {
      setSubmitState(PreloaderButtonState.Enabled);
      if (err.code) {
        unificationEmailFailed(err.code);
      } else {
        unificationEmailFailed();
      }
      if (notificationRef && notificationRef.current) {
        notificationRef.current.scrollIntoView({ behavior: "smooth" });
      }
    });
  };

  React.useEffect(() => {
    document.title = t("signIn:documentTitle");
    pushDataToSegment(MULTIPLE_ACCOUNT_FOUND_PAGE, true);
  }, [t]);

  const getContent = () => {
    return (
      <>
        <Box mb="to-actions">
          <Box mb={4}>
            <Typography
              data-testid="multipleAccountMessageHeading"
              fontSkin="title-headline"
            >
              {t("multipleAccountMessage.heading") }
            </Typography>
          </Box>
          <Box mb={4}>
            <Typography fontSkin="body-standard">
              {t("multipleAccountMessage.content") }
            </Typography>
          </Box>
          <Typography fontSkin="body-standard">
            {t("multipleAccountMessage.resendEmailInstruction") }
          </Typography>
        </Box>
        <Button
          skin="primary"
          size="standard"
          width="full-width"
          iconPosition="right"
          marginTop="4"
          marginBottom="4"
          marginRight="4"
          onClick={onClick}
          disabled={submitState === PreloaderButtonState.Preloader}
        >
          {submitState === PreloaderButtonState.Preloader
            ? (
            <>
              <Spinner
                size="tiny"
                accessibleText={t(
                  "multipleAccountMessage.preloaderAccessibilityLabel"
                )}
              />
              <>{t("multipleAccountMessage.preloaderText")}</>
            </>
              )
            : (
            <>{t("multipleAccountMessage.buttonTitle")}</>
              )}
        </Button>
      </>
    );
  };

  return (
    <>
      <BoundedContent>
        <GridContainer mb={margins.heading.sign.bottom}>
          <Row>
              <Column
                span={12}
                offset={0}
                spanSm={8}
                offsetSm={2}
                spanMd={6}
                offsetMd={3}
                spanLg={4}
                offsetLg={4}
                spanXl={4}
                offsetXl={4}
              >
                {getContent()}
              </Column>
          </Row>
        </GridContainer>
      </BoundedContent>
    </>
  );
};

export default MultipleAccounts;
